module.exports = __webpack_public_path__ + "static/img/9.e30082b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/9.png
// module id = WU5z
// module chunks = 0